/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IamPermission,
    IamPermissionFromJSON,
    IamPermissionFromJSONTyped,
    IamPermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateIamPermissionRequest
 */
export interface CreateIamPermissionRequest {
    /**
     * 
     * @type {IamPermission}
     * @memberof CreateIamPermissionRequest
     */
    iamPermission: IamPermission;
}

export function CreateIamPermissionRequestFromJSON(json: any): CreateIamPermissionRequest {
    return CreateIamPermissionRequestFromJSONTyped(json, false);
}

export function CreateIamPermissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIamPermissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamPermission': IamPermissionFromJSON(json['iam_permission']),
    };
}

export function CreateIamPermissionRequestToJSON(value?: CreateIamPermissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_permission': IamPermissionToJSON(value.iamPermission),
    };
}


